window.CatalogoController = ControllerBase.extend({
    name: "CatalogoController",
    framework: "knockout",
    region: "#catalogo-region",

    aposBinding: function() {

        $("#accordionCatalogo").on("shown.bs.collapse",
            function(e) {

                var target = $("a[role=button]", $(e.target).parent());

                setTimeout(function() {
                        $("html, body")
                            .animate({
                                    scrollTop: target.offset().top
                                },
                                1000);
                    },
                    500);


            });

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });

    },

    abrir: function(model, e) {

        var id = "#collapse" + model.TypeName();
        $(".panel-collapse.in").collapse("hide");
        $(id).collapse("show");
    },

    selecionar: function(model, e) {

        setTimeout(function() {
                $("html, body")
                    .animate({
                            scrollTop: $(e.target).offset().top
                        },
                        1000);
            },
            500);


    }


});